import { useTranslation } from 'components/signup/components/Translation'
import checkIcon from '../static/icon-check.svg'
import css from '../style.module.scss'

export const PremiumBenefits = ({ modal = false }: { modal?: boolean }) => {
  const t = useTranslation()
  return (
    <div className={`${css['sub-benefits']} ${modal ? css['sub-benefits--modal'] : ''}`}>
      <p className={css['sub-benefits-title']}>{t('your_benefits')}</p>
      <ul className={css['sub-benefits-list']}>
        <li className={css['sub-benefit-item']}>
          <span className={css['sub-benefit-icon']}>
            <img src={checkIcon} alt="checkmark" width={16} className={css['tick-icon']} />
          </span>
          <span className={css['sub-benefit-text']}>{t('benefits_1')}</span>
        </li>
        <li className={css['sub-benefit-item']}>
          <span className={css['sub-benefit-icon']}>
            <img src={checkIcon} alt="checkmark" width={16} className={css['tick-icon']} />
          </span>
          <span className={css['sub-benefit-text']}>{t('benefits_2')}</span>
        </li>
        <li className={css['sub-benefit-item']}>
          <span className={css['sub-benefit-icon']}>
            <img src={checkIcon} alt="checkmark" width={16} className={css['tick-icon']} />
          </span>
          <span className={css['sub-benefit-text']}>{t('benefits_3')}</span>
        </li>
        <li className={css['sub-benefit-item']}>
          <span className={css['sub-benefit-icon']}>
            <img src={checkIcon} alt="checkmark" width={16} className={css['tick-icon']} />
          </span>
          <span className={css['sub-benefit-text']}>{t('benefits_4')}</span>
        </li>
        <li className={css['sub-benefit-item']}>
          <span className={css['sub-benefit-icon']}>
            <img src={checkIcon} alt="checkmark" width={16} className={css['tick-icon']} />
          </span>
          <span className={css['sub-benefit-text']}>{t('benefits_5')}</span>
        </li>
        <li className={css['sub-benefit-item']}>
          <span className={css['sub-benefit-icon']}>
            <img src={checkIcon} alt="checkmark" width={16} className={css['tick-icon']} />
          </span>
          <span className={css['sub-benefit-text']}>{t('benefits_6')}</span>
        </li>
      </ul>
    </div>
  )
}
